import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'

import { fetchRemoteActions, addRemoteAction } from '../actions/remoteactions'
import { renderInputField } from '../utils/forms'

// 1 = Raspbian, 2 = Ubuntu (mismo mapeo que SoftwareVersionsView / MachineList).
const OS_LABELS = { 1: 'Raspbian', 2: 'Ubuntu' }

/* Actualización de la APP dedicada. A diferencia de CriticalActionAddForm, aquí la URL NO se
   valida por sistema operativo: se envía tal cual. La máquina descarga el binario y solo
   comprueba que el último segmento de la URL coincida con el marcador APPVERSION_ embebido. */
class AppUpdateActionAddForm extends React.Component {
  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  pendingAction() {
    const fiveMinutesAgo = Date.now() - 5 * 60 * 1000
    return (this.props.remoteActions || []).find(
      a => (a.status === 'PENDING' || a.status === 'ONPROCESS') && new Date(a.date).getTime() > fiveMinutesAgo
    )
  }

  submit(props) {
    const url = (props.arguments || '').trim()

    if (!url) {
      throw new SubmissionError({ arguments: 'Introduce la URL del binario de la app.' })
    }
    if (!/^https?:\/\//i.test(url)) {
      throw new SubmissionError({ arguments: 'La URL debe empezar por http:// o https://' })
    }
    // A propósito NO se comprueba /Ubuntu/ ni /Raspbian/: esta pestaña usa una URL única.

    const pending = this.pendingAction()
    if (pending) {
      throw new SubmissionError({
        _error: `Hay una acción remota en curso (${pending.code} — ${pending.status}). Espera a que finalice o cancélala antes de enviar una nueva.`
      })
    }

    const payload = {
      code: 'APP_UPDATE',
      arguments: url,
      machine: this.props.machine._id,
      executor: this.props.fullname,
    }

    return this.props.addRemoteAction(payload)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({ _error: response.error.message, ...response.error.fields })
        }
        this.props.fetchRemoteActions(this.props.machine.Serial)
        this.props.reset()
        return response
      })
  }

  render() {
    const { error, submitting, pristine, handleSubmit, machine, fetchRemoteActions } = this.props
    const osLabel = OS_LABELS[machine.OS || 1] || 'Desconocido'
    const pending = this.pendingAction()

    return (
      <div>
        {pending && (
          <div className="od-remote-error" style={{ marginBottom: '12px', padding: '12px 16px', borderRadius: '6px' }}>
            <i className="fas fa-hourglass-half"></i>{' '}
            Acción en curso: <strong>{pending.code}</strong> ({pending.status}). Espera a que finalice o cancélala antes de enviar una nueva.
          </div>
        )}

        {/* Columna centrada (no la rejilla de 2 columnas de .od-remote-inner). */}
        <div style={{ maxWidth: 560, margin: '0 auto', textAlign: 'center' }}>
          <div className="od-remote-section-title" style={{ justifyContent: 'center' }}>
            <i className="fas fa-shield-alt"></i> Mitigación
          </div>

          {/* Alerta clara: esta pestaña NO comprueba el sistema operativo en la URL */}
          <div style={{ background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 8, padding: '14px 16px', marginBottom: 16, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <i className="fas fa-exclamation-triangle" style={{ color: '#ea580c', fontSize: 20, marginTop: 2, flexShrink: 0 }}></i>
            <div style={{ fontSize: 13, color: '#7c2d12', lineHeight: 1.55, textAlign: 'left' }}>
              <strong style={{ display: 'block', marginBottom: 4, color: '#9a3412', fontSize: 14 }}>
                Actualización de la APP sin comprobación de sistema operativo
              </strong>
              La URL <strong>no se valida por Ubuntu/Raspbian</strong>: se envía tal cual a la máquina.
              Asegúrate de que el binario corresponde a <strong>esta</strong> máquina
              (sistema operativo <strong>{osLabel}</strong>, versión actual <strong>{machine.Sw_version || '—'}</strong>).
              Un binario incorrecto puede dejar la máquina inoperativa. La máquina descargará e
              instalará el binario en cuanto reciba la acción.
            </div>
          </div>

          <form onSubmit={handleSubmit(this.submit)} className="od-remote-form">
            <div className="od-remote-fields-row">
              <Field
                name="arguments"
                type="text"
                component={renderInputField}
                placeholder="https://vacway-updates.s3.eu-central-1.amazonaws.com/VACWAYlockers/app/V004X"
              />
            </div>
            <div className="od-remote-form-actions" style={{ justifyContent: 'center' }}>
              <button className="od-remote-submit" type="submit" disabled={pristine || submitting || !!pending}>
                <i className="fas fa-mobile-alt"></i> Enviar actualización
              </button>
              <button className="od-remote-refresh" type="button" onClick={() => fetchRemoteActions(machine.Serial)}>
                <i className="fas fa-sync"></i> Actualizar
              </button>
            </div>
            {error && <div className="od-remote-error">{error}</div>}
          </form>
        </div>
      </div>
    )
  }
}

AppUpdateActionAddForm = reduxForm({
  form: 'AppUpdateActionAddForm',
})(AppUpdateActionAddForm)

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
  remoteActions: state.remoteactions && state.remoteactions.remoteActions,
})

const mapDispatchToProps = dispatch => ({
  addRemoteAction: bindActionCreators(addRemoteAction, dispatch),
  fetchRemoteActions: bindActionCreators(fetchRemoteActions, dispatch),
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(AppUpdateActionAddForm)
